/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file PhosphorusView.jsx
 * @author Daniel Aguirre
 * @description Phosphorus View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * Phosphorus View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function PhosphorusView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getPhosphorus } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Bajo',
        color: styleGuideColors.baxterBrandTeal
      },
      {
        label: 'Normal',
        color: styleGuideColors.baxterBrandBaxterBlue
      },
      {
        label: 'Alto',
        color: styleGuideColors.graphYellow
      },
      {
        label: 'Critico',
        color: styleGuideColors.alertError
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              key: label,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    }
  };

  useEffect(() => {
    setChartData(null);
    getPhosphorus({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const { key: classification, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/phosphorus/${classification}/${totalItems}`
    );
  };

  return chartData ? (
    <DashboardDoughnut
      dataValues={chartData}
      onDetailClick={handleDetailClick}
    />
  ) : (
    <Spin />
  );
}

/**
 * Component definition of proptypes.
 */
PhosphorusView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPhosphorus: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PhosphorusView;
